import React from "react";
import { connect } from "react-redux";
import { Modal, Input, Row, Col, Checkbox, Button, Alert, Select, Form } from "antd";
import IntlMessages from "util/IntlMessages";
import { injectIntl } from 'react-intl';
import Auth from "components/Auth";
import Swal from 'sweetalert2';
import Parser from 'html-react-parser';

import {
  getTypeExtraitOptions,
  getLangueOptions,
  getDiffusionOptions
} from 'util/ValueList/Options';

import {
  projetAction,
  setStatusProjetAction
} from "appRedux/actions/Common";

import {
  STATUT_PROJET_EN_ATTENTE,
  STATUT_PROJET_SUCCES,
  STATUT_PROJET_ERREUR
} from "constants/General";

import logoCastingMachine from "assets/images/logo-casting-machine.webp";

const { TextArea } = Input;
const Option = Select.Option;

class Projet extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      destroyOnClose: true,
      selectedFile: null,
      selectedFileName: '',
      statusProjet: STATUT_PROJET_EN_ATTENTE,
      showModalAuth: false,
      vueAuth: '',
    };

    this.formValues = null;
  }

  componentDidUpdate(prevProps) {
    var intl = this.props.intl;

    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
    }

    if (prevProps.statusProjet !== this.props.statusProjet) {
      this.setState({ statusProjet: this.props.statusProjet });

      if (this.props.statusProjet === STATUT_PROJET_SUCCES) {
        Swal.fire({
          imageUrl: logoCastingMachine,
          imageWidth: 180,
          buttonsStyling: false,
          customClass: { confirmButton: 'ant-btn ant-btn-primary', cancelButton: 'ant-btn' },
          title: intl.formatMessage({ id: "projet.success.titre" }),
          html: intl.formatMessage({ id: "projet.success.text" }),
        });

        this.onCancel();
      } else if (this.props.statusProjet === STATUT_PROJET_ERREUR) {
      }
    }
  }

  ////////////////////////////////////////////////////////
  // Auth / Show-Hide
  ///////////////////////////////////////////////////////

  onHideModalAuth = () => {
    this.setState({
      showModalAuth: false,
      vueAuth: '',
      visible: true,
    });
  }

  onSignInSuccess = () => {
    this.setState({
      showModalAuth: false,
      vueAuth: '',
      visible: true,
    });

    this.sendForm();
  }

  onSignUpSuccess = () => {
    this.setState({
      showModalAuth: false,
      vueAuth: '',
      visible: true,
    });

    this.sendForm();
  }

  ////////////////////////////////////////////////////////
  // Cancel Modal
  ///////////////////////////////////////////////////////

  onCancel = () => {
    this.setState({
      visible: false,
      destroyOnClose: true
    });
    this.props.onCancel();
    this.props.setStatusProjetAction(STATUT_PROJET_EN_ATTENTE);
  };

  ////////////////////////////////////////////////////////
  // Form
  ///////////////////////////////////////////////////////

  onFileChange = (e) => {
    this.setState({ selectedFile: e.target.files[0] });
    this.setState({ selectedFileName: e.target.files[0].name });
  }

  sendForm = () => {
    const { currentUser, dataSignUp, dataSignIn } = this.props;

    var senderId = null;
    if (currentUser) {
      senderId = currentUser.id;
    } else if (dataSignIn) {
      senderId = dataSignIn.userId;
    } else if (dataSignUp) {
      senderId = dataSignUp.id;
    }

    if (senderId) {
      this.props.projetAction(senderId, this.formValues, this.state.selectedFile);
    }

  }

  handleSubmit = (values) => {
    const { currentUser } = this.props

    this.formValues = values;

    if (!currentUser) {
      this.setState({
        showModalAuth: true,
        vueAuth: 'signUp',
        visible: false,
        destroyOnClose: false,
      });
    } else {
      this.sendForm();
    }
  }

  render() {
    const { statusProjet } = this.state;
    const { currentUser } = this.props;

    var intl = this.props.intl;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 },
      },
    };

    return (
      <div>
        <Modal
          title={<IntlMessages id="projet.titre" />}
          wrapClassName="cm-modal-projet"
          visible={this.state.visible}
          onCancel={this.onCancel}
          destroyOnClose={this.state.destroyOnClose}
          footer={[
          ]}
        >
          <Form
            onFinish={this.handleSubmit}
            id="projetForm"
            name="projetForm"
            labelAlign='left'
          >

            <Row>
              <Col xl={24} lg={24} md={24} sm={24} xs={24} className="cm-projet-intro">
                {currentUser && currentUser.prenom ? `${currentUser.prenom}, ` : ''} <IntlMessages id="projet.intro" />
              </Col>
            </Row>

            {statusProjet === STATUT_PROJET_ERREUR ?
              <div style={{ marginBottom: "10px", textAlign: "center" }}>
                <Alert message={Parser(intl.formatMessage({ id: "projet.error" }))} type="error" />
              </div>
              : null}

            <Form.Item
              name='nomCasting'
              label=''
              rules={[{ required: true, message: <IntlMessages id="input.validation.obligatoire" /> }]}
              {...formItemLayout}
            >
              <Input
                type="text"
                placeholder={intl.formatMessage({ id: "projet.nomCasting.placeholder" })}
              />
            </Form.Item>

            <Row>
              <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  name='typeProjet'
                  label=''
                  rules={[{ required: true, message: <IntlMessages id="input.validation.obligatoire" /> }]}
                  {...formItemLayout}
                >
                  {getTypeExtraitOptions({ placeholder: intl.formatMessage({ id: "projet.typeProjet.placeholder" }) })}
                </Form.Item>
              </Col>
              <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  name='diffusion'
                  label=''
                  rules={[{ required: true, message: <IntlMessages id="input.validation.obligatoire" /> }]}
                  {...formItemLayout}
                >
                  {getDiffusionOptions({ placeholder: intl.formatMessage({ id: "projet.diffusion.placeholder" }) })}
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  name='genre'
                  label=''
                  rules={[{ required: true, message: <IntlMessages id="input.validation.obligatoire" /> }]}
                  {...formItemLayout}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder={intl.formatMessage({ id: "projet.genre.placeholder" })}
                  >
                    <Option value="Homme"><IntlMessages id="projet.genre.homme" /></Option>
                    <Option value="Femme"><IntlMessages id="projet.genre.femme" /></Option>
                    <Option value="Les deux"><IntlMessages id="projet.genre.lesDeux" /></Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                <Form.Item
                  name='langues'
                  label=''
                  rules={[{ required: true, message: <IntlMessages id="input.validation.obligatoire" /> }]}
                  {...formItemLayout}
                >
                  {getLangueOptions({ placeholder: intl.formatMessage({ id: "projet.langues.placeholder" }), multiple: true })}
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name='description'
              label={<IntlMessages id="projet.description.label" />}
              rules={[{ required: true, message: <IntlMessages id="input.validation.obligatoire" />, whitespace: true }]}
              {...formItemLayout}
            >
              <TextArea
                //maxLength={maxNbPresCharacters}
                multiline="true"
                rows={6}
                placeholder={intl.formatMessage({ id: "projet.description.placeholder" })}
              />
            </Form.Item>

            <Form.Item
              name='lieuEnregistrement'
              label=''
              rules={[{ required: false, message: <IntlMessages id="input.validation.obligatoire" /> }]}
              {...formItemLayout}
            >
              <Input
                type="text"
                placeholder={intl.formatMessage({ id: "projet.lieuEnregistrement.placeholder" })}
              />
            </Form.Item>

            <Form.Item
              name='pasStudioEnregistrement'
              label=''
              valuePropName='checked'
              initialValue={false}
              rules={[]}
              {...formItemLayout}
            >
              <Checkbox>
                <IntlMessages id="projet.pasStudioEnregistrement.label" />
              </Checkbox>
            </Form.Item>

            <Form.Item
              {...formItemLayout}
            >
              <div className="cm-modal-projet-file-container">
                <input style={{ opacity: "0", display: "none" }}
                  type="file"
                  id="file"
                  name="file"
                  title="Joindre un fichier"
                  //accept=".m" 
                  onChange={this.onFileChange}
                />
                <div className="cm-modal-projet-file-name">
                  <span style={{ paddingRight: "12px" }}>
                    {this.state.selectedFileName}
                  </span>
                </div>
                <div className="cm-modal-projet-file-button">
                  <label htmlFor="file">
                    <IntlMessages id="projet.fichier.button" />
                  </label>
                </div>
              </div>
            </Form.Item>

            <Form.Item
              {...formItemLayout}
            >
              <Button
                type="primary"
                key="submit"
                htmlType="submit"
                form='projetForm'
                style={{ width: "100%", margin: "0" }}
              >
                <IntlMessages id="projet.submitButton" />
              </Button>
            </Form.Item>

          </Form>

        </Modal>

        <Auth
          visible={this.state.showModalAuth}
          vue={this.state.vueAuth}
          onCancel={this.onHideModalAuth}
          onSignInSuccess={this.onSignInSuccess}
          onSignUpSuccess={this.onSignUpSuccess}
          signUpButtonText={<IntlMessages id="signUp.continuer.button" />}
        />
      </div>
    )
  }

}

const mapStateToProps = ({ common, auth }) => {
  const {
    statusProjet
  } = common;

  const {
    dataSignUp,
    dataSignIn,
    currentUser
  } = auth;

  return {
    statusProjet,
    dataSignUp,
    dataSignIn,
    currentUser
  }
};

export default connect(
  mapStateToProps,
  {
    projetAction,
    setStatusProjetAction,
  }
)(injectIntl(Projet));
